export function removeIDFromMeta (meta) {
  return meta.map(item => {
    if (item.id) delete item.id

    return item
  })
}

export function validateMeta (meta) {
  let isValid = true
  let prevCut = null
  const cuts = meta.filter(item => item.meta.action === 'cut-start' || item.meta.action === 'cut-stop')

  if (meta.length === 0) {
    isValid = true
    return isValid
  }

  if (cuts.length < 2 || cuts.length % 2 !== 0) {
    isValid = false
    return isValid
  }
  cuts.forEach(item => {
    if (
      (item.meta.action === 'cut-start' && prevCut === 'cut-start') ||
      (item.meta.action === 'cut-stop' && prevCut === 'cut-stop')
    ) {
      isValid = false
    }
    prevCut = item.meta.action
  })

  return isValid
}



// WEBPACK FOOTER //
// ./src/components/Processing/lib/utils.js